// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__U7sBy","label":"Category_label__2W5Cc","content":"Category_content__2RTVd","header":"Category_header__24qt6","location":"Category_location__oPRPG"};